export function maskPercentage(value) {
    value = Number(value.replace(/[^\d]/g, ''));

    if (value === 10000 || value >= 100000) {
        return '999.99';
    }

    return value >= 1000 ? '99.99' : '9.99';
}

export function maskLatitude(value) {
    const trimmed = String(value ?? '').trim();
    const absolute = trimmed.replace('-', '');

    const negative = trimmed.startsWith('-');

    if (absolute[1] === '.') {
        return negative ? '-9.999999' : '9.999999';
    }

    return negative ? '-99.999999' : '99.999999';
}

export function maskLongitude(value) {
    const trimmed = String(value ?? '').trim();
    const absolute = trimmed.replace('-', '');

    const negative = trimmed.startsWith('-');

    if (absolute[1] === '.') {
        return negative ? '-9.999999' : '9.999999';
    }

    if (absolute[2] === '.') {
        return negative ? '-99.999999' : '99.999999';
    }

    return negative ? '-999.999999' : '999.999999';
}

export function maskFloat(value, max = '999999999', decimals = '99') {
    const defaultMask = max + '.' + decimals;
    const input = String(value).trim();

    if (!input.includes('.')) {
        return defaultMask;
    }

    const intValue = input.split('.')[0];

    if (intValue.length > max.length) {
        return defaultMask;
    }

    return '9'.repeat(intValue.length) + '.' + decimals;
}

export function maskBedAndBath(value) {
    const trimmed = String(value ?? '').trim();

    if (trimmed[1] === '/') {
        return '9/999';
    }

    if (trimmed[2] === '/') {
        return '99/999';
    }

    return '999/999';
}
